<template>
    <div class="flx-box">
        <div class="feature-box" v-for="item in attrs.featureContentList" :key="item.title">
            <img :src="require('@/assets/' + item.showUrl)">
            <div>
                <p class="title-self">{{ item.title }}</p>
                <div class="content">{{ item.content }}</div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useAttrs } from 'vue';

const attrs = useAttrs()

</script>
<style scoped lang="less">
.flx-box{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -30px;
    .feature-box {
        flex-shrink: 0;
        width: 270px;
        height: 244px;
        text-align: center;
        background: #F0F4FF;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        margin-right: 30px;
        margin-bottom: 30px;
        &:nth-child(4n){
            margin-right: 0px;
        }
        img {
            width: 84px;
            height: 84px;
            margin: 4px 0px 24px;
        }
        p.title-self{
            font-weight: 500;
            font-size: 18px;
            color: #3A466A;
            line-height: 32px;
        }
        .content {
            margin-top: 4px;
            font-weight: 400;
            font-size: 14px;
            color: #969EBA;
            line-height: 24px;
        }
    }
}
</style>